import type { RouteObject } from 'react-router';

import * as searchEventsHorizonRouteExports from '#/modules/search/pages/Events/SearchEvents.horizon-route';
import * as searchInternshipsHorizonRouteExports from '#/modules/search/pages/Internships/SearchInternships.horizon-route';
import * as searchJobsHorizonRouteExports from '#/modules/search/pages/Jobs/SearchJobs.horizon-route';
import * as searchOrgsHorizonRouteExports from '#/modules/search/pages/Orgs/SearchOrgs.horizon-route';
import * as savedSearchRedirectHorizonRouteExports from '#/modules/search/pages/SavedSearchRedirect/SavedSearchRedirect.horizon-route';
import * as searchVolopsHorizonRouteExports from '#/modules/search/pages/Volops/SearchVolops.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import {
  searchEventsRoutePaths,
  searchInternshipsRoutePaths,
  searchJobsRoutePaths,
  searchOrgsRoutePaths,
  searchVolopsRoutePaths,
} from './search.route-paths';
import { redirectToSavedSearchRoute } from './search.routes';

export const searchRouteObjects = [
  {
    path: redirectToSavedSearchRoute.fullPath,
    ...horizonRouteToObject(savedSearchRedirectHorizonRouteExports),
  },

  ...searchJobsRoutePaths.map((path) => ({
    path,
    ...horizonRouteToObject(searchJobsHorizonRouteExports),
  })),

  ...searchInternshipsRoutePaths.map((path) => ({
    path,
    ...horizonRouteToObject(searchInternshipsHorizonRouteExports),
  })),

  ...searchVolopsRoutePaths.map((path) => ({
    path,
    ...horizonRouteToObject(searchVolopsHorizonRouteExports),
  })),

  ...searchEventsRoutePaths.map((path) => ({
    path,
    ...horizonRouteToObject(searchEventsHorizonRouteExports),
  })),

  ...searchOrgsRoutePaths.map((path) => ({
    path,
    ...horizonRouteToObject(searchOrgsHorizonRouteExports),
  })),
] satisfies RouteObject[];
